// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Plate$BwaxAdmin = require("../../../../bwax-js/ml/plate.bs.js");
var Lang_eval$BwaxAdmin = require("../../../../bwax-js/ml/lang/lang_eval.bs.js");
var Caml_chrome_debugger = require("bs-platform/lib/js/caml_chrome_debugger.js");
var Widget_common$BwaxAdmin = require("./widget_common.bs.js");
var Runtime_common$BwaxAdmin = require("../../../../bwax-js/ml/lang/mod/runtime_common.bs.js");

var module_name = "Input";

function pack_element(module_element) {
  return /* Delegated */Caml_chrome_debugger.variant("Delegated", 23, [
            module_name,
            module_element
          ]);
}

function as_placeholder(v) {
  var match = v[0];
  if (typeof match === "number" || match.tag !== /* V_raw */7) {
    return ;
  } else {
    return match[0];
  }
}

function as_int(v) {
  var match = v[0];
  if (typeof match === "number" || match.tag !== /* V_literal */5) {
    return ;
  } else {
    var match$1 = match[0];
    if (typeof match$1 === "number" || match$1.tag) {
      return ;
    } else {
      return match$1[0];
    }
  }
}

function fail(name) {
  throw [
        Lang_eval$BwaxAdmin.Eval_exn,
        module_name + ("." + (name + ": Invalid Arguments"))
      ];
}

function inputText_func(is_multiline) {
  return Widget_common$BwaxAdmin.pack_element_func(2, (function (param) {
                if (param) {
                  var match = param[0][0];
                  if (typeof match === "number" || match.tag !== /* V_list */1) {
                    return fail("text");
                  } else {
                    var match$1 = param[1];
                    if (match$1) {
                      var match$2 = match$1[0][0];
                      if (typeof match$2 === "number" || !(match$2.tag === /* V_record */2 && !match$1[1])) {
                        return fail("text");
                      } else {
                        var config = match$2[0];
                        var m_onChange = Plate$BwaxAdmin.List.assoc("onChange", config);
                        var m_value = Plate$BwaxAdmin.List.assoc("value", config);
                        var disabled = Plate$BwaxAdmin.$$Option.with_default(false, Plate$BwaxAdmin.$$Option.and_then(Lang_eval$BwaxAdmin.as_bool, Plate$BwaxAdmin.List.assoc("disabled", config)));
                        var rules = Widget_common$BwaxAdmin.raw_to_rules(match[0]);
                        var onChange;
                        if (m_onChange !== undefined) {
                          var v_onChange = m_onChange;
                          onChange = (function (str) {
                              var v_000 = /* V_literal */Caml_chrome_debugger.variant("V_literal", 5, [/* String */Caml_chrome_debugger.variant("String", 2, [str])]);
                              var v = /* tuple */[
                                v_000,
                                Runtime_common$BwaxAdmin.nt
                              ];
                              return Lang_eval$BwaxAdmin.apply_value(undefined, v_onChange, v, Runtime_common$BwaxAdmin.nt);
                            });
                        } else {
                          onChange = undefined;
                        }
                        var value;
                        if (m_value !== undefined) {
                          var match$3 = m_value[0];
                          if (typeof match$3 === "number" || match$3.tag !== /* V_tagged */6) {
                            value = undefined;
                          } else {
                            var match$4 = match$3[1];
                            if (match$4) {
                              var match$5 = match$4[0][0];
                              if (typeof match$5 === "number" || match$5.tag !== /* V_literal */5) {
                                value = undefined;
                              } else {
                                var match$6 = match$5[0];
                                value = typeof match$6 === "number" || !(match$6.tag === /* String */2 && !match$4[1]) ? undefined : match$6[0];
                              }
                            } else {
                              value = undefined;
                            }
                          }
                        } else {
                          value = undefined;
                        }
                        var m_placeholder = Plate$BwaxAdmin.List.assoc("placeholder", config);
                        var placeholder = m_placeholder !== undefined ? Plate$BwaxAdmin.$$Option.and_then(as_placeholder, Lang_eval$BwaxAdmin.as_option(m_placeholder)) : undefined;
                        var m_maxLength = Plate$BwaxAdmin.List.assoc("maxLength", config);
                        var maxLength = m_maxLength !== undefined ? Plate$BwaxAdmin.$$Option.and_then(as_int, Lang_eval$BwaxAdmin.as_option(m_maxLength)) : undefined;
                        if (is_multiline) {
                          return /* Delegated */Caml_chrome_debugger.variant("Delegated", 23, [
                                    module_name,
                                    /* Input_multiline */Caml_chrome_debugger.variant("Input_multiline", 1, [
                                        rules,
                                        onChange,
                                        value,
                                        placeholder,
                                        maxLength,
                                        disabled
                                      ])
                                  ]);
                        } else {
                          return /* Delegated */Caml_chrome_debugger.variant("Delegated", 23, [
                                    module_name,
                                    /* Input_text */Caml_chrome_debugger.variant("Input_text", 0, [
                                        rules,
                                        onChange,
                                        value,
                                        placeholder,
                                        maxLength,
                                        disabled
                                      ])
                                  ]);
                        }
                      }
                    } else {
                      return fail("text");
                    }
                  }
                } else {
                  return fail("text");
                }
              }));
}

function proc(s) {
  return /* Placeholder_text */Caml_chrome_debugger.variant("Placeholder_text", 0, [s]);
}

var externals_vals_000 = /* tuple */[
  "placeholderText",
  Widget_common$BwaxAdmin.string_to_raw(proc, "placeholderText")
];

var externals_vals_001 = /* :: */Caml_chrome_debugger.simpleVariant("::", [
    /* tuple */[
      "text",
      inputText_func(false)
    ],
    /* :: */Caml_chrome_debugger.simpleVariant("::", [
        /* tuple */[
          "multiline",
          inputText_func(true)
        ],
        /* :: */Caml_chrome_debugger.simpleVariant("::", [
            /* tuple */[
              "int",
              Widget_common$BwaxAdmin.pack_element_func(2, (function (param) {
                      if (param) {
                        var match = param[0][0];
                        if (typeof match === "number" || match.tag !== /* V_list */1) {
                          return fail("int");
                        } else {
                          var match$1 = param[1];
                          if (match$1) {
                            var match$2 = match$1[0][0];
                            if (typeof match$2 === "number" || !(match$2.tag === /* V_record */2 && !match$1[1])) {
                              return fail("int");
                            } else {
                              var config = match$2[0];
                              var m_onChange = Plate$BwaxAdmin.List.assoc("onChange", config);
                              var m_value = Plate$BwaxAdmin.List.assoc("value", config);
                              var m_placeholder = Plate$BwaxAdmin.List.assoc("placeholder", config);
                              var disabled = Plate$BwaxAdmin.$$Option.with_default(false, Plate$BwaxAdmin.$$Option.and_then(Lang_eval$BwaxAdmin.as_bool, Plate$BwaxAdmin.List.assoc("disabled", config)));
                              var placeholder = m_placeholder !== undefined ? Plate$BwaxAdmin.$$Option.and_then(as_placeholder, Lang_eval$BwaxAdmin.as_option(m_placeholder)) : undefined;
                              var rules = Widget_common$BwaxAdmin.raw_to_rules(match[0]);
                              if (m_onChange !== undefined && m_value !== undefined) {
                                var v_onChange = m_onChange;
                                var onChange = function (mi) {
                                  var v = mi !== undefined ? /* tuple */[
                                      Runtime_common$BwaxAdmin.just(/* tuple */[
                                            /* V_literal */Caml_chrome_debugger.variant("V_literal", 5, [/* Int */Caml_chrome_debugger.variant("Int", 0, [mi])]),
                                            Runtime_common$BwaxAdmin.nt
                                          ]),
                                      Runtime_common$BwaxAdmin.nt
                                    ] : /* tuple */[
                                      Runtime_common$BwaxAdmin.nothing,
                                      Runtime_common$BwaxAdmin.nt
                                    ];
                                  return Lang_eval$BwaxAdmin.apply_value(undefined, v_onChange, v, Runtime_common$BwaxAdmin.nt);
                                };
                                var value = Plate$BwaxAdmin.$$Option.and_then(as_int, Lang_eval$BwaxAdmin.as_option(m_value));
                                return /* Delegated */Caml_chrome_debugger.variant("Delegated", 23, [
                                          module_name,
                                          /* Input_int */Caml_chrome_debugger.variant("Input_int", 2, [
                                              rules,
                                              onChange,
                                              value,
                                              placeholder,
                                              disabled
                                            ])
                                        ]);
                              } else {
                                return fail("int");
                              }
                            }
                          } else {
                            return fail("int");
                          }
                        }
                      } else {
                        return fail("int");
                      }
                    }))
            ],
            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                /* tuple */[
                  "decimal",
                  Widget_common$BwaxAdmin.pack_element_func(2, (function (param) {
                          if (param) {
                            var match = param[0][0];
                            if (typeof match === "number" || match.tag !== /* V_list */1) {
                              return fail("decimal");
                            } else {
                              var match$1 = param[1];
                              if (match$1) {
                                var match$2 = match$1[0][0];
                                if (typeof match$2 === "number" || !(match$2.tag === /* V_record */2 && !match$1[1])) {
                                  return fail("decimal");
                                } else {
                                  var config = match$2[0];
                                  var m_onChange = Plate$BwaxAdmin.List.assoc("onChange", config);
                                  var m_value = Plate$BwaxAdmin.List.assoc("value", config);
                                  var m_placeholder = Plate$BwaxAdmin.List.assoc("placeholder", config);
                                  var placeholder = m_placeholder !== undefined ? Plate$BwaxAdmin.$$Option.and_then(as_placeholder, Lang_eval$BwaxAdmin.as_option(m_placeholder)) : undefined;
                                  var disabled = Plate$BwaxAdmin.$$Option.with_default(false, Plate$BwaxAdmin.$$Option.and_then(Lang_eval$BwaxAdmin.as_bool, Plate$BwaxAdmin.List.assoc("disabled", config)));
                                  var rules = Widget_common$BwaxAdmin.raw_to_rules(match[0]);
                                  if (m_onChange !== undefined && m_value !== undefined) {
                                    var v_onChange = m_onChange;
                                    var onChange = function (mf) {
                                      var v = mf !== undefined ? /* tuple */[
                                          Runtime_common$BwaxAdmin.just(/* tuple */[
                                                /* V_literal */Caml_chrome_debugger.variant("V_literal", 5, [/* Float */Caml_chrome_debugger.variant("Float", 1, [mf])]),
                                                Runtime_common$BwaxAdmin.nt
                                              ]),
                                          Runtime_common$BwaxAdmin.nt
                                        ] : /* tuple */[
                                          Runtime_common$BwaxAdmin.nothing,
                                          Runtime_common$BwaxAdmin.nt
                                        ];
                                      return Lang_eval$BwaxAdmin.apply_value(undefined, v_onChange, v, Runtime_common$BwaxAdmin.nt);
                                    };
                                    var value = Plate$BwaxAdmin.$$Option.and_then(Lang_eval$BwaxAdmin.as_float, Lang_eval$BwaxAdmin.as_option(m_value));
                                    return /* Delegated */Caml_chrome_debugger.variant("Delegated", 23, [
                                              module_name,
                                              /* Input_decimal */Caml_chrome_debugger.variant("Input_decimal", 3, [
                                                  rules,
                                                  onChange,
                                                  value,
                                                  placeholder,
                                                  disabled
                                                ])
                                            ]);
                                  } else {
                                    return fail("decimal");
                                  }
                                }
                              } else {
                                return fail("decimal");
                              }
                            }
                          } else {
                            return fail("decimal");
                          }
                        }))
                ],
                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                    /* tuple */[
                      "radio",
                      Widget_common$BwaxAdmin.pack_element_func(4, (function (param) {
                              if (param) {
                                var match = param[0][0];
                                if (typeof match === "number" || match.tag !== /* V_list */1) {
                                  return fail("radio");
                                } else {
                                  var match$1 = param[1];
                                  if (match$1) {
                                    var match$2 = match$1[0][0];
                                    if (typeof match$2 === "number" || match$2.tag !== /* V_list */1) {
                                      return fail("radio");
                                    } else {
                                      var match$3 = match$1[1];
                                      if (match$3) {
                                        var match$4 = match$3[0][0];
                                        if (typeof match$4 === "number" || match$4.tag !== /* V_list */1) {
                                          return fail("radio");
                                        } else {
                                          var match$5 = match$3[1];
                                          if (match$5) {
                                            var match$6 = match$5[0][0];
                                            if (typeof match$6 === "number" || !(match$6.tag === /* V_record */2 && !match$5[1])) {
                                              return fail("radio");
                                            } else {
                                              var config = match$6[0];
                                              var m_onChange = Plate$BwaxAdmin.List.assoc("onChange", config);
                                              var m_selected = Plate$BwaxAdmin.List.assoc("selected", config);
                                              var m_color = Plate$BwaxAdmin.List.assoc("color", config);
                                              var m_disabled = Plate$BwaxAdmin.List.assoc("disabled", config);
                                              var m_align = Plate$BwaxAdmin.List.assoc("align", config);
                                              var disabled;
                                              if (m_disabled !== undefined) {
                                                var match$7 = m_disabled[0];
                                                if (typeof match$7 === "number" || match$7.tag !== /* V_literal */5) {
                                                  disabled = false;
                                                } else {
                                                  var match$8 = match$7[0];
                                                  disabled = typeof match$8 === "number" || match$8.tag !== /* Bool */4 ? false : match$8[0];
                                                }
                                              } else {
                                                disabled = false;
                                              }
                                              var align;
                                              if (m_align !== undefined) {
                                                var match$9 = m_align[0];
                                                align = typeof match$9 === "number" || !(match$9.tag === /* V_tagged */6 && match$9[0] === "ROW") ? /* column */-963948842 : /* row */5693978;
                                              } else {
                                                align = /* column */-963948842;
                                              }
                                              var color = m_color !== undefined ? Widget_common$BwaxAdmin.make_color(m_color) : /* text */-856044371;
                                              var rules = Widget_common$BwaxAdmin.raw_to_rules(match[0]);
                                              var option_rules = Widget_common$BwaxAdmin.raw_to_rules(match$2[0]);
                                              var convert_select_option = function (o) {
                                                var mlabel = Plate$BwaxAdmin.$$Option.and_then(Lang_eval$BwaxAdmin.as_string, Lang_eval$BwaxAdmin.get_field("label", o));
                                                var mvalue = Plate$BwaxAdmin.$$Option.and_then(Lang_eval$BwaxAdmin.as_string, Lang_eval$BwaxAdmin.get_field("value", o));
                                                if (mlabel !== undefined && mvalue !== undefined) {
                                                  return /* record */Caml_chrome_debugger.record([
                                                            "value",
                                                            "label"
                                                          ], [
                                                            mvalue,
                                                            mlabel
                                                          ]);
                                                }
                                                
                                              };
                                              var options = Plate$BwaxAdmin.List.keep_map(convert_select_option, match$4[0]);
                                              if (m_onChange !== undefined && m_selected !== undefined) {
                                                var v_onChange = m_onChange;
                                                var onChange = function (ms) {
                                                  var v = ms !== undefined ? /* tuple */[
                                                      Runtime_common$BwaxAdmin.just(/* tuple */[
                                                            /* V_literal */Caml_chrome_debugger.variant("V_literal", 5, [/* String */Caml_chrome_debugger.variant("String", 2, [ms])]),
                                                            Runtime_common$BwaxAdmin.nt
                                                          ]),
                                                      Runtime_common$BwaxAdmin.nt
                                                    ] : /* tuple */[
                                                      Runtime_common$BwaxAdmin.nothing,
                                                      Runtime_common$BwaxAdmin.nt
                                                    ];
                                                  return Lang_eval$BwaxAdmin.apply_value(undefined, v_onChange, v, Runtime_common$BwaxAdmin.nt);
                                                };
                                                var selected = Plate$BwaxAdmin.$$Option.and_then(Lang_eval$BwaxAdmin.as_string, Lang_eval$BwaxAdmin.as_option(m_selected));
                                                return /* Delegated */Caml_chrome_debugger.variant("Delegated", 23, [
                                                          module_name,
                                                          /* Input_radio */Caml_chrome_debugger.variant("Input_radio", 4, [
                                                              rules,
                                                              option_rules,
                                                              options,
                                                              selected,
                                                              onChange,
                                                              disabled,
                                                              color,
                                                              align
                                                            ])
                                                        ]);
                                              } else {
                                                return fail("radio");
                                              }
                                            }
                                          } else {
                                            return fail("radio");
                                          }
                                        }
                                      } else {
                                        return fail("radio");
                                      }
                                    }
                                  } else {
                                    return fail("radio");
                                  }
                                }
                              } else {
                                return fail("radio");
                              }
                            }))
                    ],
                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                        /* tuple */[
                          "checkboxes",
                          Widget_common$BwaxAdmin.pack_element_func(4, (function (param) {
                                  if (param) {
                                    var match = param[0][0];
                                    if (typeof match === "number" || match.tag !== /* V_list */1) {
                                      return fail("checkboxes");
                                    } else {
                                      var match$1 = param[1];
                                      if (match$1) {
                                        var match$2 = match$1[0][0];
                                        if (typeof match$2 === "number" || match$2.tag !== /* V_list */1) {
                                          return fail("checkboxes");
                                        } else {
                                          var match$3 = match$1[1];
                                          if (match$3) {
                                            var match$4 = match$3[0][0];
                                            if (typeof match$4 === "number" || match$4.tag !== /* V_list */1) {
                                              return fail("checkboxes");
                                            } else {
                                              var match$5 = match$3[1];
                                              if (match$5) {
                                                var match$6 = match$5[0][0];
                                                if (typeof match$6 === "number" || !(match$6.tag === /* V_record */2 && !match$5[1])) {
                                                  return fail("checkboxes");
                                                } else {
                                                  var config = match$6[0];
                                                  var m_onChange = Plate$BwaxAdmin.List.assoc("onChange", config);
                                                  var m_selected = Plate$BwaxAdmin.List.assoc("selected", config);
                                                  var m_color = Plate$BwaxAdmin.List.assoc("color", config);
                                                  var m_disabled = Plate$BwaxAdmin.List.assoc("disabled", config);
                                                  var m_align = Plate$BwaxAdmin.List.assoc("align", config);
                                                  var disabled;
                                                  if (m_disabled !== undefined) {
                                                    var match$7 = m_disabled[0];
                                                    if (typeof match$7 === "number" || match$7.tag !== /* V_literal */5) {
                                                      disabled = false;
                                                    } else {
                                                      var match$8 = match$7[0];
                                                      disabled = typeof match$8 === "number" || match$8.tag !== /* Bool */4 ? false : match$8[0];
                                                    }
                                                  } else {
                                                    disabled = false;
                                                  }
                                                  var align;
                                                  if (m_align !== undefined) {
                                                    var match$9 = m_align[0];
                                                    align = typeof match$9 === "number" || !(match$9.tag === /* V_tagged */6 && match$9[0] === "ROW") ? /* column */-963948842 : /* row */5693978;
                                                  } else {
                                                    align = /* column */-963948842;
                                                  }
                                                  var color = m_color !== undefined ? Widget_common$BwaxAdmin.make_color(m_color) : /* text */-856044371;
                                                  var rules = Widget_common$BwaxAdmin.raw_to_rules(match[0]);
                                                  var option_rules = Widget_common$BwaxAdmin.raw_to_rules(match$2[0]);
                                                  var convert_select_option = function (o) {
                                                    var mlabel = Plate$BwaxAdmin.$$Option.and_then(Lang_eval$BwaxAdmin.as_string, Lang_eval$BwaxAdmin.get_field("label", o));
                                                    var mvalue = Plate$BwaxAdmin.$$Option.and_then(Lang_eval$BwaxAdmin.as_string, Lang_eval$BwaxAdmin.get_field("value", o));
                                                    if (mlabel !== undefined && mvalue !== undefined) {
                                                      return /* record */Caml_chrome_debugger.record([
                                                                "value",
                                                                "label"
                                                              ], [
                                                                mvalue,
                                                                mlabel
                                                              ]);
                                                    }
                                                    
                                                  };
                                                  var options = Plate$BwaxAdmin.List.keep_map(convert_select_option, match$4[0]);
                                                  if (m_onChange !== undefined && m_selected !== undefined) {
                                                    var v_onChange = m_onChange;
                                                    var onChange = function (l) {
                                                      var v = Runtime_common$BwaxAdmin.pack_list(Plate$BwaxAdmin.List.map(Runtime_common$BwaxAdmin.pack_string, l));
                                                      return Lang_eval$BwaxAdmin.apply_value(undefined, v_onChange, v, Runtime_common$BwaxAdmin.nt);
                                                    };
                                                    var selected = Plate$BwaxAdmin.List.keep_map(Lang_eval$BwaxAdmin.as_string, Plate$BwaxAdmin.$$Option.with_default(/* [] */0, Lang_eval$BwaxAdmin.as_list(m_selected)));
                                                    return /* Delegated */Caml_chrome_debugger.variant("Delegated", 23, [
                                                              module_name,
                                                              /* Input_checkboxes */Caml_chrome_debugger.variant("Input_checkboxes", 5, [
                                                                  rules,
                                                                  option_rules,
                                                                  options,
                                                                  selected,
                                                                  onChange,
                                                                  disabled,
                                                                  color,
                                                                  align
                                                                ])
                                                            ]);
                                                  } else {
                                                    return fail("checkboxes");
                                                  }
                                                }
                                              } else {
                                                return fail("checkboxes");
                                              }
                                            }
                                          } else {
                                            return fail("checkboxes");
                                          }
                                        }
                                      } else {
                                        return fail("checkboxes");
                                      }
                                    }
                                  } else {
                                    return fail("checkboxes");
                                  }
                                }))
                        ],
                        /* :: */Caml_chrome_debugger.simpleVariant("::", [
                            /* tuple */[
                              "checkbox",
                              Widget_common$BwaxAdmin.pack_element_func(2, (function (param) {
                                      if (param) {
                                        var match = param[0][0];
                                        if (typeof match === "number" || match.tag !== /* V_list */1) {
                                          return fail("checkbox");
                                        } else {
                                          var match$1 = param[1];
                                          if (match$1) {
                                            var match$2 = match$1[0][0];
                                            if (typeof match$2 === "number" || !(match$2.tag === /* V_record */2 && !match$1[1])) {
                                              return fail("checkbox");
                                            } else {
                                              var config = match$2[0];
                                              var m_onChange = Plate$BwaxAdmin.List.assoc("onChange", config);
                                              var m_checked = Plate$BwaxAdmin.List.assoc("checked", config);
                                              var m_color = Plate$BwaxAdmin.List.assoc("color", config);
                                              var m_disabled = Plate$BwaxAdmin.List.assoc("disabled", config);
                                              var disabled;
                                              if (m_disabled !== undefined) {
                                                var match$3 = m_disabled[0];
                                                if (typeof match$3 === "number" || match$3.tag !== /* V_literal */5) {
                                                  disabled = false;
                                                } else {
                                                  var match$4 = match$3[0];
                                                  disabled = typeof match$4 === "number" || match$4.tag !== /* Bool */4 ? false : match$4[0];
                                                }
                                              } else {
                                                disabled = false;
                                              }
                                              var color = m_color !== undefined ? Widget_common$BwaxAdmin.make_color(m_color) : /* text */-856044371;
                                              var rules = Widget_common$BwaxAdmin.raw_to_rules(match[0]);
                                              if (m_onChange !== undefined && m_checked !== undefined) {
                                                var v_onChange = m_onChange;
                                                var onChange = function (b) {
                                                  var v_000 = /* V_literal */Caml_chrome_debugger.variant("V_literal", 5, [/* Bool */Caml_chrome_debugger.variant("Bool", 4, [b])]);
                                                  var v = /* tuple */[
                                                    v_000,
                                                    Runtime_common$BwaxAdmin.nt
                                                  ];
                                                  return Lang_eval$BwaxAdmin.apply_value(undefined, v_onChange, v, Runtime_common$BwaxAdmin.nt);
                                                };
                                                var checked = Plate$BwaxAdmin.$$Option.with_default(false, Lang_eval$BwaxAdmin.as_bool(m_checked));
                                                return /* Delegated */Caml_chrome_debugger.variant("Delegated", 23, [
                                                          module_name,
                                                          /* Input_checkbox */Caml_chrome_debugger.variant("Input_checkbox", 6, [
                                                              rules,
                                                              checked,
                                                              onChange,
                                                              disabled,
                                                              color
                                                            ])
                                                        ]);
                                              } else {
                                                return fail("checkbox");
                                              }
                                            }
                                          } else {
                                            return fail("checkbox");
                                          }
                                        }
                                      } else {
                                        return fail("checkbox");
                                      }
                                    }))
                            ],
                            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                /* tuple */[
                                  "select",
                                  Widget_common$BwaxAdmin.pack_element_func(4, (function (param) {
                                          if (param) {
                                            var match = param[0][0];
                                            if (typeof match === "number" || match.tag !== /* V_list */1) {
                                              return fail("select");
                                            } else {
                                              var match$1 = param[1];
                                              if (match$1) {
                                                var match$2 = match$1[0][0];
                                                if (typeof match$2 === "number" || match$2.tag !== /* V_record */2) {
                                                  return fail("select");
                                                } else {
                                                  var match$3 = match$1[1];
                                                  if (match$3) {
                                                    var match$4 = match$3[0][0];
                                                    if (typeof match$4 === "number" || match$4.tag !== /* V_list */1) {
                                                      return fail("select");
                                                    } else {
                                                      var match$5 = match$3[1];
                                                      if (match$5) {
                                                        var match$6 = match$5[0][0];
                                                        if (typeof match$6 === "number" || !(match$6.tag === /* V_record */2 && !match$5[1])) {
                                                          return fail("select");
                                                        } else {
                                                          var config = match$6[0];
                                                          var vrs = match$2[0];
                                                          var container_rules = Widget_common$BwaxAdmin.raw_to_rules(match[0]);
                                                          var to_rules = function (v) {
                                                            var match = v[0];
                                                            if (typeof match === "number" || match.tag !== /* V_list */1) {
                                                              return /* [] */0;
                                                            } else {
                                                              return Widget_common$BwaxAdmin.raw_to_rules(match[0]);
                                                            }
                                                          };
                                                          var extract_rules = function (name) {
                                                            return Plate$BwaxAdmin.$$Option.with_default(/* [] */0, Plate$BwaxAdmin.$$Option.map(to_rules, Plate$BwaxAdmin.List.assoc(name, vrs)));
                                                          };
                                                          var control_rules = extract_rules("control");
                                                          var menu_rules = extract_rules("menu");
                                                          var optionList_rules = extract_rules("optionList");
                                                          var option_rules = function (label, value, selected, disabled) {
                                                            var match = Plate$BwaxAdmin.List.assoc("option", vrs);
                                                            if (match !== undefined) {
                                                              var args_000 = /* tuple */[
                                                                /* V_literal */Caml_chrome_debugger.variant("V_literal", 5, [/* String */Caml_chrome_debugger.variant("String", 2, [label])]),
                                                                Runtime_common$BwaxAdmin.nt
                                                              ];
                                                              var args_001 = /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                  /* tuple */[
                                                                    /* V_literal */Caml_chrome_debugger.variant("V_literal", 5, [/* String */Caml_chrome_debugger.variant("String", 2, [value])]),
                                                                    Runtime_common$BwaxAdmin.nt
                                                                  ],
                                                                  /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                      /* tuple */[
                                                                        /* V_literal */Caml_chrome_debugger.variant("V_literal", 5, [/* Bool */Caml_chrome_debugger.variant("Bool", 4, [selected])]),
                                                                        Runtime_common$BwaxAdmin.nt
                                                                      ],
                                                                      /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                          /* tuple */[
                                                                            /* V_literal */Caml_chrome_debugger.variant("V_literal", 5, [/* Bool */Caml_chrome_debugger.variant("Bool", 4, [disabled])]),
                                                                            Runtime_common$BwaxAdmin.nt
                                                                          ],
                                                                          /* [] */0
                                                                        ])
                                                                    ])
                                                                ]);
                                                              var args = /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                  args_000,
                                                                  args_001
                                                                ]);
                                                              return to_rules(Lang_eval$BwaxAdmin.apply_value_args(module_name, match, args, Runtime_common$BwaxAdmin.nt));
                                                            } else {
                                                              return /* [] */0;
                                                            }
                                                          };
                                                          var singleValue_rules = function (label, value) {
                                                            var match = Plate$BwaxAdmin.List.assoc("singleValue", vrs);
                                                            if (match !== undefined) {
                                                              var args_000 = /* tuple */[
                                                                /* V_literal */Caml_chrome_debugger.variant("V_literal", 5, [/* String */Caml_chrome_debugger.variant("String", 2, [label])]),
                                                                Runtime_common$BwaxAdmin.nt
                                                              ];
                                                              var args_001 = /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                  /* tuple */[
                                                                    /* V_literal */Caml_chrome_debugger.variant("V_literal", 5, [/* String */Caml_chrome_debugger.variant("String", 2, [value])]),
                                                                    Runtime_common$BwaxAdmin.nt
                                                                  ],
                                                                  /* [] */0
                                                                ]);
                                                              var args = /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                  args_000,
                                                                  args_001
                                                                ]);
                                                              return to_rules(Lang_eval$BwaxAdmin.apply_value_args(module_name, match, args, Runtime_common$BwaxAdmin.nt));
                                                            } else {
                                                              return /* [] */0;
                                                            }
                                                          };
                                                          var controlFocused_rules = extract_rules("controlFocused");
                                                          var optionFocused_rules = function (label, value, selected) {
                                                            var match = Plate$BwaxAdmin.List.assoc("optionFocused", vrs);
                                                            if (match !== undefined) {
                                                              var args_000 = /* tuple */[
                                                                /* V_literal */Caml_chrome_debugger.variant("V_literal", 5, [/* String */Caml_chrome_debugger.variant("String", 2, [label])]),
                                                                Runtime_common$BwaxAdmin.nt
                                                              ];
                                                              var args_001 = /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                  /* tuple */[
                                                                    /* V_literal */Caml_chrome_debugger.variant("V_literal", 5, [/* String */Caml_chrome_debugger.variant("String", 2, [value])]),
                                                                    Runtime_common$BwaxAdmin.nt
                                                                  ],
                                                                  /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                      /* tuple */[
                                                                        /* V_literal */Caml_chrome_debugger.variant("V_literal", 5, [/* Bool */Caml_chrome_debugger.variant("Bool", 4, [selected])]),
                                                                        Runtime_common$BwaxAdmin.nt
                                                                      ],
                                                                      /* [] */0
                                                                    ])
                                                                ]);
                                                              var args = /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                  args_000,
                                                                  args_001
                                                                ]);
                                                              return to_rules(Lang_eval$BwaxAdmin.apply_value_args(module_name, match, args, Runtime_common$BwaxAdmin.nt));
                                                            } else {
                                                              return /* [] */0;
                                                            }
                                                          };
                                                          var convert = function (o) {
                                                            var match = o[0];
                                                            if (typeof match === "number" || match.tag) {
                                                              return ;
                                                            } else {
                                                              var match$1 = match[0];
                                                              if (match$1) {
                                                                var match$2 = match$1[0][0];
                                                                if (typeof match$2 === "number" || match$2.tag !== /* V_literal */5) {
                                                                  return ;
                                                                } else {
                                                                  var match$3 = match$2[0];
                                                                  if (typeof match$3 === "number" || match$3.tag !== /* String */2) {
                                                                    return ;
                                                                  } else {
                                                                    var match$4 = match$1[1];
                                                                    if (match$4) {
                                                                      var match$5 = match$4[0][0];
                                                                      if (typeof match$5 === "number" || match$5.tag !== /* V_literal */5) {
                                                                        return ;
                                                                      } else {
                                                                        var match$6 = match$5[0];
                                                                        if (typeof match$6 === "number" || match$6.tag !== /* String */2) {
                                                                          return ;
                                                                        } else {
                                                                          var match$7 = match$4[1];
                                                                          if (match$7) {
                                                                            var match$8 = match$7[0][0];
                                                                            if (typeof match$8 === "number" || match$8.tag !== /* V_literal */5) {
                                                                              return ;
                                                                            } else {
                                                                              var match$9 = match$8[0];
                                                                              if (typeof match$9 === "number" || !(match$9.tag === /* Bool */4 && !match$7[1])) {
                                                                                return ;
                                                                              } else {
                                                                                return /* tuple */[
                                                                                        match$3[0],
                                                                                        match$6[0],
                                                                                        match$9[0]
                                                                                      ];
                                                                              }
                                                                            }
                                                                          } else {
                                                                            return ;
                                                                          }
                                                                        }
                                                                      }
                                                                    } else {
                                                                      return ;
                                                                    }
                                                                  }
                                                                }
                                                              } else {
                                                                return ;
                                                              }
                                                            }
                                                          };
                                                          var options = Plate$BwaxAdmin.List.keep_map(convert, match$4[0]);
                                                          var m_onChange = Plate$BwaxAdmin.List.assoc("onChange", config);
                                                          var m_selected = Plate$BwaxAdmin.List.assoc("selected", config);
                                                          var m_disabled = Plate$BwaxAdmin.List.assoc("disabled", config);
                                                          var selected;
                                                          if (m_selected !== undefined) {
                                                            var match$7 = m_selected[0];
                                                            if (typeof match$7 === "number" || match$7.tag !== /* V_tagged */6) {
                                                              selected = undefined;
                                                            } else {
                                                              var match$8 = match$7[1];
                                                              if (match$8) {
                                                                var match$9 = match$8[0][0];
                                                                if (typeof match$9 === "number" || match$9.tag !== /* V_literal */5) {
                                                                  selected = undefined;
                                                                } else {
                                                                  var match$10 = match$9[0];
                                                                  selected = typeof match$10 === "number" || !(match$10.tag === /* String */2 && !match$8[1]) ? undefined : match$10[0];
                                                                }
                                                              } else {
                                                                selected = undefined;
                                                              }
                                                            }
                                                          } else {
                                                            selected = undefined;
                                                          }
                                                          var onChange;
                                                          if (m_onChange !== undefined) {
                                                            var v_onChange = m_onChange;
                                                            onChange = (function (ms) {
                                                                var v = ms !== undefined ? /* tuple */[
                                                                    Runtime_common$BwaxAdmin.just(/* tuple */[
                                                                          /* V_literal */Caml_chrome_debugger.variant("V_literal", 5, [/* String */Caml_chrome_debugger.variant("String", 2, [ms])]),
                                                                          Runtime_common$BwaxAdmin.nt
                                                                        ]),
                                                                    Runtime_common$BwaxAdmin.nt
                                                                  ] : /* tuple */[
                                                                    Runtime_common$BwaxAdmin.nothing,
                                                                    Runtime_common$BwaxAdmin.nt
                                                                  ];
                                                                return Lang_eval$BwaxAdmin.apply_value(undefined, v_onChange, v, Runtime_common$BwaxAdmin.nt);
                                                              });
                                                          } else {
                                                            onChange = undefined;
                                                          }
                                                          var disabled;
                                                          if (m_disabled !== undefined) {
                                                            var match$11 = m_disabled[0];
                                                            if (typeof match$11 === "number" || match$11.tag !== /* V_literal */5) {
                                                              disabled = false;
                                                            } else {
                                                              var match$12 = match$11[0];
                                                              disabled = typeof match$12 === "number" || match$12.tag !== /* Bool */4 ? false : match$12[0];
                                                            }
                                                          } else {
                                                            disabled = false;
                                                          }
                                                          var m_placeholder = Plate$BwaxAdmin.List.assoc("placeholder", config);
                                                          var placeholder = m_placeholder !== undefined ? Plate$BwaxAdmin.$$Option.and_then(as_placeholder, Lang_eval$BwaxAdmin.as_option(m_placeholder)) : undefined;
                                                          return /* Delegated */Caml_chrome_debugger.variant("Delegated", 23, [
                                                                    module_name,
                                                                    /* Input_select */Caml_chrome_debugger.variant("Input_select", 7, [
                                                                        container_rules,
                                                                        control_rules,
                                                                        menu_rules,
                                                                        optionList_rules,
                                                                        option_rules,
                                                                        singleValue_rules,
                                                                        controlFocused_rules,
                                                                        optionFocused_rules,
                                                                        options,
                                                                        selected,
                                                                        onChange,
                                                                        disabled,
                                                                        placeholder
                                                                      ])
                                                                  ]);
                                                        }
                                                      } else {
                                                        return fail("select");
                                                      }
                                                    }
                                                  } else {
                                                    return fail("select");
                                                  }
                                                }
                                              } else {
                                                return fail("select");
                                              }
                                            }
                                          } else {
                                            return fail("select");
                                          }
                                        }))
                                ],
                                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                    /* tuple */[
                                      "chooseFile",
                                      Widget_common$BwaxAdmin.pack_element_func(3, (function (param) {
                                              if (param) {
                                                var match = param[0][0];
                                                if (typeof match === "number" || match.tag !== /* V_list */1) {
                                                  return fail("chooseFile");
                                                } else {
                                                  var match$1 = param[1];
                                                  if (match$1) {
                                                    var match$2 = match$1[0][0];
                                                    if (typeof match$2 === "number" || match$2.tag !== /* V_record */2) {
                                                      return fail("chooseFile");
                                                    } else {
                                                      var match$3 = match$1[1];
                                                      if (match$3) {
                                                        var match$4 = match$3[0][0];
                                                        if (typeof match$4 === "number" || !(match$4.tag === /* V_raw */7 && !match$3[1])) {
                                                          return fail("chooseFile");
                                                        } else {
                                                          var config = match$2[0];
                                                          var rules = Widget_common$BwaxAdmin.raw_to_rules(match[0]);
                                                          var m_onChoose = Plate$BwaxAdmin.List.assoc("onChoose", config);
                                                          var match$5 = Plate$BwaxAdmin.List.assoc("accept", config);
                                                          var accept;
                                                          if (match$5 !== undefined) {
                                                            var match$6 = match$5[0];
                                                            if (typeof match$6 === "number" || match$6.tag !== /* V_literal */5) {
                                                              accept = undefined;
                                                            } else {
                                                              var match$7 = match$6[0];
                                                              accept = typeof match$7 === "number" || match$7.tag !== /* String */2 ? undefined : match$7[0];
                                                            }
                                                          } else {
                                                            accept = undefined;
                                                          }
                                                          var onChoose;
                                                          if (m_onChoose !== undefined) {
                                                            var v_onChoose = m_onChoose;
                                                            onChoose = (function (mf) {
                                                                var v = mf !== undefined ? /* tuple */[
                                                                    Runtime_common$BwaxAdmin.just(/* tuple */[
                                                                          /* V_tagged_raw */Caml_chrome_debugger.variant("V_tagged_raw", 8, [
                                                                              "LocalFile",
                                                                              Caml_option.valFromOption(mf)
                                                                            ]),
                                                                          Runtime_common$BwaxAdmin.nt
                                                                        ]),
                                                                    Runtime_common$BwaxAdmin.nt
                                                                  ] : /* tuple */[
                                                                    Runtime_common$BwaxAdmin.nothing,
                                                                    Runtime_common$BwaxAdmin.nt
                                                                  ];
                                                                return Lang_eval$BwaxAdmin.apply_value(undefined, v_onChoose, v, Runtime_common$BwaxAdmin.nt);
                                                              });
                                                          } else {
                                                            onChoose = fail("chooseFile");
                                                          }
                                                          return /* Delegated */Caml_chrome_debugger.variant("Delegated", 23, [
                                                                    module_name,
                                                                    /* Input_chooseFile */Caml_chrome_debugger.variant("Input_chooseFile", 8, [
                                                                        rules,
                                                                        onChoose,
                                                                        accept,
                                                                        match$4[0]
                                                                      ])
                                                                  ]);
                                                        }
                                                      } else {
                                                        return fail("chooseFile");
                                                      }
                                                    }
                                                  } else {
                                                    return fail("chooseFile");
                                                  }
                                                }
                                              } else {
                                                return fail("chooseFile");
                                              }
                                            }))
                                    ],
                                    /* [] */0
                                  ])
                              ])
                          ])
                      ])
                  ])
              ])
          ])
      ])
  ]);

var externals_vals = /* :: */Caml_chrome_debugger.simpleVariant("::", [
    externals_vals_000,
    externals_vals_001
  ]);

var externals_000 = module_name;

var externals = /* tuple */[
  externals_000,
  externals_vals
];

var src = "\nmodule Input;\n\nimport Element exposing (Rule, Element);\n\n--- placeholder 是不是要有更高级的设计？\n--- 暂时用这个，方便后续的扩展\ntype Placeholder msg = opaque;\n\nplaceholderText: String -> Placeholder msg = external;\n\ntext: List (Rule msg)  \n        -> ~{ onChange: String -> msg!\n            , value: Maybe String!\n            , placeholder: Maybe (Placeholder msg) \n            , maxLength: Maybe Int\n            , disabled: Bool\n            } \n        -> Element msg = external;\n\nmultiline: \n  List (Rule msg)  \n        -> ~{ onChange: String -> msg!\n            , value: Maybe String!\n            , placeholder: Maybe (Placeholder msg) \n            , disabled: Bool\n            } \n        -> Element msg = external;\n\nint: List (Rule msg) \n        -> ~{ onChange: Maybe Int -> msg!\n            , value: Maybe Int!\n            , placeholder: Maybe (Placeholder msg) \n            , disabled: Bool\n            }\n        -> Element msg = external;\n\ndecimal: List (Rule msg)\n        -> ~{ onChange: Maybe Float -> msg!\n            , value: Maybe Float!\n            , placeholder: Maybe (Placeholder msg) \n            , disabled: Bool\n            }\n        -> Element msg = external;\n\n\n-- date: \n--      List (Rule msg)\n--    -> ~{}  -- 用于不同的样式设置，如 date 等\n\n\ntype OptionAlignment = ROW | COLUMN;\n\n-- rules -> option rules -> options -> config\nradio: \n      List (Rule msg) \n    -> List (Rule msg) \n    -> List { label: String, value: String }  \n    -> ~{ selected: Maybe String!\n        , onChange: Maybe String -> msg!\n        , disabled: Bool\n        , color: Color\n        , align: OptionAlignment\n       }\n    -> Element msg = external;\n\n\ncheckbox:\n      List (Rule msg)\n    -> ~{ checked: Bool!\n        , onChange: Bool -> msg!\n        , disabled: Bool\n        , color: Color\n       }\n    -> Element msg = external;\n\n\n-- container rules, option rules, options, and then the config\ncheckboxes:\n      List (Rule msg)\n    -> List (Rule msg)\n    -> List { label: String, value: String }\n    -> ~{ selected: List String!\n        , onChange: List String -> msg!\n        , disabled: Bool\n        , color: Color\n        , align: OptionAlignment\n        }\n    -> Element msg = external;\n\n\nselect: \n      List (Rule msg) -- container rule\n    -> ~{ control: List (Rule msg)\n        , menu: List (Rule msg)\n        , optionList: List (Rule msg)\n        -- label -> value -> isSelected -> isDisabled -> rules\n        , option: String -> String -> Bool -> Bool -> List (Rule msg)\n        , singleValue: String -> String -> List (Rule msg)\n        , controlFocused: List (Rule msg)\n        -- label -> value -> isSelected -> rules\n        , optionFocused: String -> String -> Bool -> List (Rule msg)\n        }\n    -> List (String, String, Bool)\n    -> ~{ selected: Maybe String!\n        , onChange: Maybe String -> msg!\n        , disabled: Bool\n        , placeholder: Maybe (Placeholder msg) \n        }\n    -> Element msg = external;\n\n\nchooseFile:\n      List (Rule msg)\n    -> ~{ onChoose: Maybe LocalFile -> msg!, accept: String }\n    -> Element msg \n    -> Element msg = external;\n\n";

exports.module_name = module_name;
exports.pack_element = pack_element;
exports.src = src;
exports.as_placeholder = as_placeholder;
exports.as_int = as_int;
exports.fail = fail;
exports.inputText_func = inputText_func;
exports.externals_vals = externals_vals;
exports.externals = externals;
/* externals_vals Not a pure module */
